export interface WarehouseNotificationConfig {
  id: number;
  location: string;
  subject: string;
  body: string;
  template_variables: string[];
}

export interface WarehouseGroupMember {
  membership_id: number;
  id: number;
  full_name: string;
  email: string;
}

export interface WarehouseDepartmentGroup {
  group_id: string;
  users: WarehouseGroupMember[];
}

export interface AssignableUser {
  id: number;
  full_name: string;
  email: string;
}

export const warehouseNotificationConfigUrl = (location: string): string =>
  `/warehouse/notification_configs/${location}`;

export const warehouseDepartmentGroupsUrl = '/warehouse/department_group_memberships';

export const warehouseAssignableUsersUrl = '/warehouse/assignable_users';
